import { Table } from "@/features/Table";
import { type N1StaticDatum, porfolios_columns } from "./columns";
import {
  type FilterN1StaticDatumsSchema,
  FilterN1StaticDatums,
} from "./filter";
import { Clients } from "@/lib/clients";
import { Tables } from "@/gen/tableNames/tables";

export const N1StaticDatumsTable = () => {
  return (
    <Table<N1StaticDatum, FilterN1StaticDatumsSchema>
      label="Actifs"
      client={Clients.N1}
      table_name={Tables.N1_STATIC_DATA}
      columns={porfolios_columns}
      filter={<FilterN1StaticDatums />}
      actions={[
        {
          label: "actions.new",
          route: `${Clients.N1}/${Tables.N1_STATIC_DATA}/new`,
        },
      ]}
    />
  );
};
